/* This file is generated from build configuration */
export default {
    camerasDbUrl: "https://ugcs-build-artifacts.s3.eu-west-1.amazonaws.com/cameras-db/cameras-db.json"
}
